import { Box, FormControl, Grid, Paper, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { FetchProducerProfile } from '../libs/hooks/queries'
import { AuthContext } from '../libs/contexts/authContext'
import InputMask from 'react-input-mask'

const ProducerProfile = () => {
  const [profile, setProfile] = useState({
    npn: '',
    agentID: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    workAddress: '',
    workAddress2: '',
    workCity: '',
    workState: '',
    workZip: '',
  })
  const { affiliateCode: affiliateCodeFromContext } = useContext(AuthContext)
  const { data } = FetchProducerProfile({ affiliateCode: affiliateCodeFromContext })
  useEffect(() => {
    if (!data) return
    console.log({ data })
    setProfile(data)
  }, [data])

  return (
    <div
      style={{
        backgroundColor: 'rgba(241, 243, 246, 1)',
        paddingTop: '100px',
        fontFamily: 'Roboto',
        minHeight: '100vh',
      }}
    >
      <Paper elevation={3} sx={profileStyle.containerBox}>
        <Typography variant="h4" textAlign={'left'}>
          Profile
        </Typography>
        <Typography variant="subtitle2" sx={profileStyle.subtitle} textAlign={'left'}>
          Please contact the Contracting and Licensing Team at 866-830-2181 or <a href="">licensing@cgic.com</a> if any
          of your contact information requires updating.
        </Typography>
        <Grid container rowSpacing={2} mt={1} justifyContent={'center'}>
          <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
            <FormControl fullWidth>
              <TextField
                id="outlined-disabled"
                label="National Producer Number (NPN)"
                value={profile.npn}
                InputLabelProps={{ shrink: true }}
                sx={profileStyle.textField}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
            <FormControl fullWidth>
              <TextField
                id="outlined-disabled"
                label="Continental General Producer Number"
                value={profile.agentID}
                InputLabelProps={{ shrink: true }}
                sx={profileStyle.textField}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid
            container
            justifyContent={'center'}
            mt={2}
            columnGap={1}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            pl={'0!important'}
          >
            <Grid item lg={5.8} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="First Name"
                  value={profile.firstName}
                  sx={profileStyle.textField}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
              </FormControl>
            </Grid>
            <Grid item lg={6} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="Last Name"
                  value={profile.lastName}
                  sx={profileStyle.textField}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
            <FormControl fullWidth>
              <TextField
                id="outlined-disabled"
                label="Work Email Address"
                value={profile.email}
                InputLabelProps={{ shrink: true }}
                sx={profileStyle.textField}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
            <FormControl fullWidth>
              <InputMask mask="(999) 999-9999" value={profile.phone} disabled>
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    id="outlined-disabled"
                    label="Mobile Phone Number"
                    type="phone"
                    InputLabelProps={{ shrink: true }}
                    sx={{ input: { ...profileStyle.textField, color: 'rgba(0, 0, 0, 0.38)!important' } }}
                    disabled
                    // helperText={invalidAgtId ? agtIdMsg : ''}
                  />
                )}
              </InputMask>
            </FormControl>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
            <FormControl fullWidth>
              <TextField
                id="outlined-disabled"
                label="Street Address 1"
                value={profile.workAddress}
                InputLabelProps={{ shrink: true }}
                sx={profileStyle.textField}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} pl={'0!important'}>
            <FormControl fullWidth>
              <TextField
                id="outlined-disabled"
                label="Street Address 2"
                value={profile.workAddress2}
                InputLabelProps={{ shrink: true }}
                sx={profileStyle.textField}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid
            container
            justifyContent={'center'}
            mt={2}
            columnGap={1}
            lg={12}
            md={12}
            sm={12}
            xs={12}
            pl={'0!important'}
          >
            <Grid item lg={4} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="City"
                  value={profile.workCity}
                  sx={profileStyle.textField}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
              </FormControl>
            </Grid>
            <Grid item lg={3.8} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="State"
                  value={profile.workState}
                  sx={profileStyle.textField}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
              </FormControl>
            </Grid>
            <Grid item lg={3.8} md={12} sm={12} xs={12} pl={'0!important'}>
              <FormControl fullWidth>
                <TextField
                  id="outlined-disabled"
                  label="Zipcode"
                  value={profile.workZip}
                  sx={profileStyle.textField}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  // helperText={invalidAgtId ? agtIdMsg : ''}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}

const profileStyle = {
  containerBox: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',
    gap: 1,
    width: { lg: '626px', md: '770px', sm: '770px', xs: '343px' },
    maxWidth: { lg: '522px', md: '770px', sm: '770px', xs: '343px' },
    height: 'auto',
    background: '#FFFF',
    margin: 'auto',
    padding: { lg: '64px 60px', md: '40px 32px ', sm: '40px 32x', xs: '16px' },
  },
  subtitle: {
    fontFamily: 'Roboto!important',
    fontWeight: '400!important',
    fontSize: '14px!important',
    color: '#64768C',
  },
  textField: {
    backgroundColor: 'white',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
    },
  },
}

export default ProducerProfile
